const url = '/supplier-interface';
const Provider = 'SupplierInterface';
const dbModel = 'SupplierInterface';

export { url, Provider, dbModel };
